import {queryBearerToken} from "./UserAuthentication";
import {putFormData} from "./FormData";
import {getCartId} from "../selectors/SimpleSelectors";
import * as ActionTypes from "../constants/ActionTypes";
import {CART_PINCODE_VERIFY_SUCCESS} from "../constants/ActionTypes";
import {MITTWALD_API, Schemas} from "../middleware/MittwaldApi";
import {cartApiEndpoint} from "../config/Config";

const fetchCartRecommend = (bearer, cartId) => ({
    [MITTWALD_API]: {
        types: [ActionTypes.CART_RECOMMEND_REQUEST, ActionTypes.CART_RECOMMEND_SUCCESS, ActionTypes.CART_RECOMMEND_FAILURE],
        endpoint: `${cartApiEndpoint}/${cartId}/actions/recommend`,
        bearer: bearer,
        schema: Schemas.RECOMMEND,
        method: 'POST'
    }
})

export const queryCartRecommend = () => (dispatch, getState) => {
    return dispatch(queryBearerToken()).then(() => {
        return dispatch(putFormData(true)).then(args => {

            return dispatch(fetchCartRecommend(getState().token.bearer, getCartId(getState()))).then(args => {
                if (args && args.type === ActionTypes.CART_RECOMMEND_SUCCESS) {

                } else {
                    alert("Bei der Ausgliederung ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.")
                }
            })
        })
    })
}

export const queryVerifySuccess = () => (dispatch, getState) => {
    dispatch({
        type: CART_PINCODE_VERIFY_SUCCESS
    });
}

const fetchVerifyPinCode = (bearer, cartId, pinCode) => ({
    [MITTWALD_API]: {
        types: [ActionTypes.CART_PINCODE_VERIFY_REQUEST, ActionTypes.CART_PINCODE_VERIFY_RESPONSE, ActionTypes.CART_PINCODE_VERIFY_FAILURE],
        endpoint: `${cartApiEndpoint}/${cartId}/actions/recommendation/verify`,
        bearer: bearer,
        schema: Schemas.STATUSCODE,
        method: 'POST',
        postData: {pinCode}
    }
})

export const queryVerifyPinCode = (pinCode) => (dispatch, getState) => {
    return dispatch(queryBearerToken()).then(() => {
        return dispatch(fetchVerifyPinCode(getState().token.bearer, getCartId(getState()), pinCode));
    })
}


export const copyValueFromElement = (element) => {

    element.select()
    document.execCommand('copy')

    if (window.getSelection) {
        if (window.getSelection().empty) {  // Chrome
            window.getSelection().empty();
        } else if (window.getSelection().removeAllRanges) {  // Firefox
            window.getSelection().removeAllRanges();
        }
    } else if (document.selection) {  // IE?
        document.selection.empty();
    }

    return true;

}


export const queryResetCopy = () => (dispatch, getState) => {
    return dispatch({
        type: ActionTypes.SEND_OFFER_COPY_RESET
    })
}


/** WEBPACK FOOTER **
 ** ./src/actions/Recommend.js
 **/